import _ from 'lodash';

const BULLET_PLACEHOLDER = '\u2022';

class LspBulletPlaceholderDirective {
  constructor() {
    this.restrict = 'A';
    this.link = (...args) => {
      args[1].attr('placeholder', _.repeat(BULLET_PLACEHOLDER, 8));
    };
  }
}

export default LspBulletPlaceholderDirective;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-bullet-placeholder/lsp-bullet-placeholder-directive.js